(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('ASTBMsoDetailController', MsoDetailController);

    MsoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Mso'];

    function MsoDetailController($scope, $rootScope, $stateParams, previousState, entity, Mso) {
        var vm = this;

        vm.mso = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('nasracApp:msoUpdate', function(event, result) {
            vm.mso = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
